/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { CookieService, DeviceService, FileService } from '@shared/data-access/services';

import { ExclusiveProductContent } from '../exclusive-product-content.interface';

import { pdpJsonFileName } from '@pdp/data-access/constants';

@Component({
	selector: 'pdp-exclusive-product-info',
	templateUrl: './exclusive-product-info.component.html',
	styleUrl: './exclusive-product-info.component.scss',
	standalone: false
})
export class ExclusiveProductInfoComponent implements OnInit {
	/**
	 * @description String representing the brand of the exclusive product.
	 */
	@Input()
	public brand: string;

	/**
	 * @description String representing the access state that will be displayed
	 *  to the user (ex. unlocked or locked).
	 */
	@Input()
	public accessState: string;

	/**
	 * @description Used to reference the json file to reference the correct
	 * data for this exclusive product.
	 */
	public content: ExclusiveProductContent;
	public isAOS: boolean;
	iconFillColor = '';

	constructor(
		public fileService: FileService,
		private deviceService: DeviceService,
		private cookieService: CookieService
	) {}

	ngOnInit() {
		if (this.cookieService.get('DSG_VH') === '112') {
			this.isAOS = true;
		} else {
			this.isAOS = false;
		}
		const EXCLUSIVE_CONTENT = this.fileService.getDataFileByType$(
			pdpJsonFileName.exclusiveContent,
			'json'
		);

		EXCLUSIVE_CONTENT.subscribe((values) => {
			this.content = values[this.brand];
			if (this.content) {
				this.iconFillColor = this.getIconFillColor();
			}
		});
	}

	/**
	 * @description Retrieves header text based on the access state of
	 * the user and if use is on mobile or desktop
	 */
	public getHeaderText() {
		if (this.deviceService.isMobile()) {
			return this.content[this.accessState]?.mobileHeaderText;
		} else {
			return this.content[this.accessState]?.headerText;
		}
	}
	public getAOSHeaderText() {
		if (this.deviceService.isMobile()) {
			return this.content[this.accessState]?.aosMobileHeaderText;
		} else {
			return this.content[this.accessState]?.aosHeaderText;
		}
	}

	getIconFillColor(): string {
		const className = this.content[this.accessState]?.iconClassName;
		const iconClassMap = {
			'unlock-icon-color': 'var(--hmf-scgreen)',
			'lock-icon-color': 'var(--hmf-gray500)',
			'gold-unlock-icon-color': '#C4AE71'
		};

		return iconClassMap[className] || '';
	}
}
